// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4328":"Widgets","5772":"plone-volto-components-manage-Controlpanels-Aliases","9824":"GDPRCookieSettingsWidget"}[chunkId] + "." + {"3724":"63b7cf60","4328":"ac119948","5772":"ac119948","9824":"1439b689"}[chunkId] + ".chunk.css";
};